'use client'

import { currencies } from '@/constants/currencies';
import useHotelDetailStore from '@/core/stores/hotelDetail';

export default function MainPrice() {

    const { totalPrice, isGetting } = useHotelDetailStore()
    
    return (
        <div className="pb-1.5 text-end flex items-end justify-end">
            {(!totalPrice || (!!totalPrice?.price)) && <span className="text-xs text-indigo-900">From </span>}
            {isGetting || !totalPrice ? <span className='bg-slate-300 ml-2 animate-pulse block rounded-md w-14 h-5'>

            </span> : totalPrice?.price && <span className="text-2xl font-bold text-gray-900">
                {currencies[totalPrice?.currency]}
                {totalPrice?.price}
            </span>}
        </div>

    );
}